import { getSubscriptionPlansUserUtil } from '../index'
import { SUBSCRIPTION_PLANS_PREMIUM_PLUS } from '../../../constants'

export function hasPremiumPlusUserUtil (user) {
  return getSubscriptionPlansUserUtil(user).find(
    (subscriptionPlan) => !!SUBSCRIPTION_PLANS_PREMIUM_PLUS.includes(subscriptionPlan)
  )
}
